import * as ngCore from '@angular/core'
import * as ngMatDatepicker from '@angular/material/datepicker'

import * as button from '../../../button'
import * as models from '../models'
import { Store } from '../store'

import * as dateRangeOverlayContent from './content'

/** TODO */
@ngCore.Component({
  encapsulation: ngCore.ViewEncapsulation.None,
  imports: [ngMatDatepicker.MatDatepickerModule, button.Component],
  selector: 'atn-ds-date-range-overlay',
  styleUrls: ['./component.scss'],
  templateUrl: './component.html',
})
export class Component
  implements ngMatDatepicker.MatDateRangeSelectionStrategy<Date>
{
  /**
   * Used to inject the custom component into overlay of
   * {@link ngMatDatepicker.MatDateRangePicker} via
   * {@link ngMatDatepicker.MatDateRangePicker.calendarHeaderComponent}
   */
  public readonly DateRangeOverlayContent = dateRangeOverlayContent.Component

  /** Emits overlay apply event */
  public readonly apply = ngCore.output<void>()
  /** Emits overlay cancel event */
  public readonly cancel = ngCore.output<void>()

  /** @see {@link Store} */
  public readonly store = ngCore.inject(Store)

  /** {@link ngMatDatepicker.MatDateRangePicker} */
  @ngCore.ViewChild('picker', { static: true })
  public readonly picker!: ngMatDatepicker.MatDateRangePicker<Date>

  /** Emit overlay apply event and close the picker */
  public applyClickHandler() {
    this.apply.emit()
    this.picker?.close()
  }

  /** Emit overlay cancel event and close the picker */
  public cancelClickHandler() {
    this.cancel.emit()
    this.picker?.close()
  }

  /** @inheritdoc */
  public selectionFinished(
    date: models.DateRange.Edge,
  ): ngMatDatepicker.DateRange<Date> {
    const currentRange = this.store.editingDateRangeSg()

    if (!date) {
      return currentRange
    }

    const { start, end } = currentRange

    let newRange: ngMatDatepicker.DateRange<Date>

    // Handle case where only end is set (form input scenario)
    if (!start && end && date < end) {
      newRange = models.DateRange.generate({ end, start: date })
    }
    // Start is not set, or both are set → start a new range
    else if (!start || (start && end)) {
      newRange = models.DateRange.generate({ start: date })
    }
    // Selected date is after or equal to start → set as end
    else if (date >= start) {
      newRange = models.DateRange.generate({ end: date, start })
    }
    // Selected date is before start → promote to new start
    else {
      newRange = models.DateRange.generate({ start: date })
    }

    if (newRange.start !== currentRange.start) {
      // start date changed
      this.store.patchState({
        editingDateRange: newRange,
        lastChanged: 'start',
      })
    } else if (newRange.end !== currentRange.end) {
      // end date changed
      this.store.patchState({
        editingDateRange: newRange,
        lastChanged: 'end',
      })
    }

    return newRange
  }

  /** @inheritdoc */
  public createPreview(
    activeDate: models.DateRange.Edge,
  ): ngMatDatepicker.DateRange<Date> {
    const currentRange = this.store.editingDateRangeSg()

    if (!activeDate) {
      return currentRange
    }

    const { start, end } = currentRange

    // If no start or both dates are already selected, start a new preview
    if (!start || (start && end)) {
      return models.DateRange.generate({ start: activeDate })
    }

    if (activeDate >= start) {
      // Preview the range from start to active date
      return models.DateRange.generate({ end: activeDate, start })
    }

    // Active date is before current start → preview with active as start
    return models.DateRange.generate({ start: activeDate })
  }
}
